var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"icon",attrs:{"src":require("common/image/bind-ok.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("你已绑定手机成功！")]),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v(_vm._s(_vm.phone))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b16a44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/bindphone/success.vue
// module id = null
// module chunks = 